/* Segway veelgestelde vragen: zoeken filtert de vragen tijdens het typen. Het open- en dichtklappen doet de browser zelf (details). */
(function () {
  var root = document.querySelector('[data-faq]');
  if (!root) return;
  var input = root.querySelector('[data-faq-search]');
  if (!input) return;
  var items = [].slice.call(root.querySelectorAll('[data-faq-item]'));
  var groups = [].slice.call(root.querySelectorAll('[data-faq-group]'));
  var empty = root.querySelector('[data-faq-empty]');

  function filter() {
    var q = input.value.toLowerCase().trim();
    var shown = 0;
    items.forEach(function (item) {
      var match = !q || item.textContent.toLowerCase().indexOf(q) > -1;
      item.hidden = !match;
      if (match) shown += 1;
      if (q && match) item.open = true;
      if (!q) item.open = false;
    });
    groups.forEach(function (group) {
      group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
    });
    if (empty) empty.hidden = shown > 0;
  }

  input.addEventListener('input', filter);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && input.value) {
      input.value = '';
      filter();
    }
  });
})();
